export default __webpack_public_path__ + "static/Pala_24-9c6201cac7d762f684684d0a6c7f539a.png";